import { createElement } from 'react';
const h1 = (props) => {
    const { title, ...others } = props;
    return createElement("h1", Object.assign({}, others), title);
};
export default h1;
